import { ajaxSend } from '../../../../api/api';

export function getPresigned(payload: any) {
  return ajaxSend({
    path: '/v1/uploads/presigned_url/announcement',
    method: 'POST',
    data: {
      pretty_name: payload.files[0].name,
      content_type: payload.files[0].type,
    },
  });
}

export function uploadAudio(payload: any) {
  return ajaxSend({
    method: 'PUT',
    headers: {
      authorization: null,
      contentType: payload.files[0].type,
    },
    data: payload.files[0],
    path: payload.presigned.upload_url,
  });
}

export function getAudios(payload: any) {
  return ajaxSend({
    path: '/v1/uploads/announcement',
  });
}
